module.exports = "https://trybtryb-legacy.web.app/img/glass-bubble.62bf691a.webp";